import Icon from "@/core/components/Icon/Icon";
import { MaterialColors } from "@/core/types/types";
import { useTheme } from "@mui/material";

interface CustomSvgProps {
  width?: string;
  height?: string;
  path: string;
  color?: string;
  fit?: boolean;
  canBeFilled?: boolean;
}

const GenericSVG = ({
  width = "24px",
  height = "24px",
  path,
  color = "secondary",
  fit = true,
  canBeFilled = true,
}: CustomSvgProps) => {
  const theme = useTheme();
  const iconColor = isMaterialColor(color) ? theme.palette[color].main : color;

  return canBeFilled ? (
    <div>
      <style jsx>{`
        div {
          width: ${width};
          min-width: ${width};
          height: ${height};
          background-color: ${iconColor};
          mask: url(${path});
          mask-repeat: no-repeat;
          mask-position: center;
          mask-size: ${fit ? "contain" : "auto"};
        }
      `}</style>
    </div>
  ) : (
    <Icon src={path} />
  );
};

function isMaterialColor(color?: string): color is MaterialColors {
  return Object.values(MaterialColors).includes(color as MaterialColors);
}

export default GenericSVG;
